{
	"name": "@1debit/analytics",
	"version": "11.4.4",
	"license": "MIT",
	"files": [
		"dist"
	],
	"main": "./dist/index.js",
	"module": "dist/index.mjs",
	"types": "./dist/index.d.ts",
	"scripts": {
		"build": "tsup",
		"dev": "tsup --watch",
		"eslint": "eslint --ext .ts,.tsx src/ --max-warnings 0",
		"type-check": "tsc --pretty --noEmit",
		"lint": "yarn type-check && yarn eslint",
		"test": "jest"
	},
	"publishConfig": {
		"access": "public",
		"registry": "https://chime.jfrog.io/artifactory/api/npm/npm-local"
	},
	"repository": {
		"type": "git",
		"url": "https://github.com/1debit/chime-frontend",
		"directory": "packages/1debit-analytics"
	},
	"dependencies": {
		"@1debit/chime-schemas": "^2.14.1761325436",
		"@1debit/device-intelligence": "^1.12.0",
		"hyperid": "^3.3.0",
		"js-cookie": "^3.0.5",
		"ua-parser-js": "^1.0.40"
	},
	"devDependencies": {
		"@1debit/eslint-config-1debit": "*",
		"@1debit/tsconfig": "*",
		"@datadog/browser-logs": "^6.22.0",
		"@testing-library/dom": "^10.4.1",
		"@testing-library/jest-dom": "^6.9.1",
		"@testing-library/react": "^16.3.0",
		"@types/jest": "^30.0.0",
		"@types/ua-parser-js": "^0.7.39",
		"eslint": "^9.39.1",
		"jest": "^30.1.3",
		"jest-environment-jsdom": "^30.1.2",
		"react": "^18.2.0",
		"react-dom": "^18.2.0",
		"ts-jest": "^29.4.5",
		"tsup": "^8.5.0",
		"typescript": "^5.9.2"
	},
	"peerDependencies": {
		"@types/react": "^18.0 || ^19.0",
		"@types/react-dom": "^18.0 || ^19.0",
		"react": "^18.0 || ^19.0",
		"react-dom": "^18.0 || ^19.0"
	}
}
